/**
 * Throws an error if the app is loaded outside of SFMC
 * when it is not running on a localhost domain.
 * However, allows the auth completion route to be loaded.
 */
export function assertSfmcParent() {
    if (window.location.pathname.endsWith("vimeo-auth-complete")) {
        return;
    }

    if (
        window.self === window.top &&
        !window.location.hostname.endsWith("localhost")
    ) {
        throw new Error(
            "This application is for use in Salesforce Marketing Cloud only."
        );
    }
}
